import { EventContentArg } from '@fullcalendar/react';
import * as React from 'react';
import * as moment from 'moment';

function DayView (eventInfo: EventContentArg) {
    const { event } = eventInfo;
    const { extendedProps, title, allDay, end, start } = event || {};
    const { categories, location, eventTitle, eventCategoryColor } = extendedProps || {};

    var timeString = "";

    if (!allDay) {

        if (start) {
            timeString += moment(start).format('hh:mm a');
        }

        if (start && end) {
            timeString += " - ";
        }

        if (end) {
            timeString += moment(end).format('hh:mm a');
        }

        timeString += " ";
    }
    return (<>
        <div title={timeString + eventTitle + (location ? " @ " + location : "") + (categories ? " - " + categories : "")}
            className="short-event-text">
            <span className="fc-list-event-dot" style={{ borderColor: eventCategoryColor }}></span>{timeString}{title}
        </div>
    </>);
}

export default DayView;